import type { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const TimeSlotButton = ({
  children,
  onClick,
  icon,
  variant = 'default',
}: {
  children: React.ReactNode
  onClick: () => void
  icon?: IconProp
  variant?: 'day' | 'night' | 'default'
}) => {
  const baseClasses = `
        inline-flex cursor-pointer items-center justify-center gap-2 rounded-lg px-4 py-3 text-sm font-medium
        transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
    `
  const variantClasses =
    variant === 'night'
      ? 'border border-indigo-200 bg-indigo-50 text-indigo-700 hover:bg-indigo-100 dark:border-indigo-900/50 dark:bg-indigo-950/30 dark:text-indigo-300 dark:hover:bg-indigo-950/50 focus-visible:ring-indigo-500'
      : 'border border-amber-200 bg-amber-50 text-amber-700 hover:bg-amber-100 dark:border-amber-900/50 dark:bg-amber-950/30 dark:text-amber-300 dark:hover:bg-amber-950/50 focus-visible:ring-amber-500'

  return (
    <button onClick={onClick} className={`${baseClasses} ${variantClasses}`}>
      {icon && <FontAwesomeIcon icon={icon} className="h-4 w-4" />}
      {children}
    </button>
  )
}
